import { sortBy } from 'instantsearch.js/es/widgets';
import getAttributeValue from '../../../../utils/getAttributeValue';
import { INSTANT_SEARCH_INDEX_NAME } from '../../../../global/algolia/algoliaInstantSearch/instantSearch';

export const initSortByWidget = () => {
	const sortByRelevanceMsg = getAttributeValue(
		'#sortBy',
		'data-sort-relevance-msg',
	);
	const sortPriceAscMsg = getAttributeValue(
		'#sortBy',
		'data-sort-price-asc-msg',
	);
	const sortPriceDescMsg = getAttributeValue(
		'#sortBy',
		'data-sort-price-desc-msg',
	);

	return sortBy({
		container: '#sortBy',
		items: [
			{ label: sortByRelevanceMsg, value: INSTANT_SEARCH_INDEX_NAME },
			{
				label: sortPriceAscMsg,
				value: `${INSTANT_SEARCH_INDEX_NAME}_price_asc`,
			},
			{
				label: sortPriceDescMsg,
				value: `${INSTANT_SEARCH_INDEX_NAME}_price_desc`,
			},
		],
	});
};

export const displaySortByWidget = () => {
	const widgetContainer = document.querySelector(
		'.algolia-search-list-page__sorting-controls',
	);
	widgetContainer?.classList.remove('d-none');
};
